import { Component, ElementRef, Input, OnInit } from "@angular/core";

@Component({
  selector: "app-example-monouse-component",
  template: `<div
    class="h-screen w-screen bg-black bg-opacity-35 fixed top-0 left-0 z-50 flex items-center place-content-center text-[40px] text-white"
  >
    Hello i'm the one time component
  </div>`,
  styles: [],
  standalone: false,
})
export class ExampleMonouseComponent implements OnInit {
  @Input() fatherElement: any = {};
  @Input() fatherContaierRef: any;

  constructor(private host: ElementRef<HTMLElement>) {}

  ngOnInit(): void {
    console.log(this.fatherElement, this.fatherContaierRef);
    setTimeout(() => {
      this.autoDestory();
    }, 3000);
  }

  autoDestory() {
    this.host.nativeElement.remove();
  }
}
